import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { ProductKit } from '../../model/ProductKit';
import { CardHeader } from './StarterKitCardHeader';
import { useModuleStore } from '../../../../enrollment-process/module-management/model/ModuleStoreHook';
import { useRootStore } from '../../../../root/RootStoreHooks';

interface DynamicKitPriceDisplayProps {
  selectedKit?: ProductKit;
  dynamicKitPrice: number;
  kit: ProductKit;
}

const DynamicKitPriceDisplay = observer<DynamicKitPriceDisplayProps>(function DynamicKitPriceDisplay({
  kit,
  selectedKit,
  dynamicKitPrice
}) {
  const { currency } = useRootStore().reference;
  const { t } = useTranslation();
  const isCurrentKit = kit === selectedKit;
  const priceDifference = Math.abs(kit.price - dynamicKitPrice);
  const sign = kit.price >= dynamicKitPrice ? '+' : '-';
  const formattedPrice = `${sign}${currency.symbol}${currency.formatDisplayAmount(priceDifference)}${currency.code}`;
  const priceToUse = isCurrentKit ? t('Included') : formattedPrice;
  return <p className="text-right text-white pr-2">{priceToUse}</p>;
});

interface CardHeaderProps {
  kit: ProductKit;
}

export const StarterKitPopularCardHeader = observer<CardHeaderProps>(function StarterKitPopularCardHeader({ kit }) {
  const store = useModuleStore('enrollmentKitSelection');
  const checked = store.selectedKit === kit;

  return (
    <CardHeader onClick={() => store.choseKit(kit)} isSelected={checked}>
      <DynamicKitPriceDisplay
        selectedKit={store.selectedKit}
        dynamicKitPrice={store.currentTab.dynamicKitPrice}
        kit={kit}
      />
    </CardHeader>
  );
});
